<div class="main-dnd">
    <h3 class="left-section-title">{{ title }}</h3>
    <div class="wrapper-dnd">
        <div class="left">
            <por-drag-n-drop
                (fileDeleted)="handleFileDelete()"
                (uploadStarted)="uploading$.next(true)"
                (uploadSuccess)="handleFile($any($event))"
                [allowedExtensions]="allowedExtensions"></por-drag-n-drop>
        </div>
        <div class="right">
            @if (uiTitle) {
            <p>{{ uiTitle }}</p>
            } @if ((uploading$ | async) === true) {
            <div class="loader"></div>
            } @else { @if (imageRendering) {
            <p class="new-image-para">{{ 'loadingNewImage' | translate }}</p>
            } @if (currentImage) {
            <div class="img-container" [ngClass]="{ banners: allowDelete }" [ngStyle]="{ height: previewDimension.height, width: previewDimension.width }">
                <img src="{{ currentImage }}" (load)="handleImageRender()" (error)="handleImageRender()" />
            </div>
            } @if (currentImage && allowDelete) {
            <por-base-button (click)="clearFile()" [featureName]="'admin-ad-delete-button-data'">
                {{ 'Remove' | translate }}
            </por-base-button>
            } }
        </div>
    </div>
</div>
